import React, { Component } from "react";
import { Col, Card, Form, Button, Icon } from "antd";
import { getCarName } from "../../../../Utils";

class UsedCarInformation extends Component {
  render() {
    const { appraisal } = this.props;
    const carName = getCarName(appraisal.carDetail);

    return appraisal ? (
      <Col xs={24} md={12}>
        <Card title="Used Car Information">
          {carName ? (
            <Form.Item label="Mobil">
              <span
                className="ant-form-text form-text-mod"
                style={{ lineHeight: "30px" }}>
                {appraisal.carName || carName}
              </span>
            </Form.Item>
          ) : null}

          {this.props.getValue(
            appraisal.carDetail,
            "fieldName",
            "Nomor Polisi"
          ) ? (
            <Form.Item label="Plat Nomor">
              <span className="ant-form-text form-text-mod">
                {this.props.getValue(
                  appraisal.carDetail,
                  "fieldName",
                  "Nomor Polisi"
                )}
              </span>
            </Form.Item>
          ) : null}

          <Form.Item>
            <Button
              type="primary"
              block
              size="large"
              onClick={() => this.props.visibleModal("Appraisal Photo", true)}>
              <span
                className="ant-form-text form-text-mod"
                style={{ color: "#FFF", float: "left" }}>
                Lihat Detail Appraisal
              </span>
              <Icon
                type="arrow-right"
                style={{ color: "#FFF", float: "right", marginTop: 5 }}></Icon>
            </Button>
          </Form.Item>
        </Card>
      </Col>
    ) : null;
  }
}

export default UsedCarInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/UsedCarInformation.js